// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperContainer-cls1_eFH","cls2":"PaperContainer-cls2_c-H PaperContainer-cls1_eFH"};